export interface HateoasError {
  status?: number;
  title?: string;
  message?: string;
  errors?: FieldMessageError[];
  _links?: Record<string, unknown>;
  _embedded?: EmbeddedErrors;
}

export interface EmbeddedErrors {
  errors?: FieldMessageError[];
}

export interface FieldMessageError {
  code?: string;
  field?: string;
  message?: string;
}
const isEmbeddedErrors = (embedded: unknown): embedded is EmbeddedErrors => {
  return embedded !== null && typeof embedded === 'object' && 'errors' in embedded;
};

/**
 * {
 *  "message": "Internal Server Error",
 *  "_links": {},
 *  "_embedded": {
 *    "errors": {}
 *  }
 * }
 */
const isHateoasError = (error: unknown): error is HateoasError => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as Record<string, unknown>;
  const hasErrorsArray = Array.isArray(candidate['errors']);
  const hasEmbeddedErrors = '_embedded' in candidate && isEmbeddedErrors(candidate['_embedded']);

  return (
    hasErrorsArray ||
    hasEmbeddedErrors ||
    ('title' in candidate && '_links' in candidate) ||
    ('message' in candidate && '_links' in candidate)
  );
};

export { isHateoasError };

export function createHateoasError(message: string, _embedded: EmbeddedErrors): HateoasError {
  return {
    message,
    title: message,
    errors: _embedded.errors,
    _links: {},
    _embedded,
  };
}
